import { finalize } from 'rxjs/operators';
import { ticketRequestError } from '../../ticket-form.utils';
import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Empty_General_Interface, General_Interface } from 'src/app/Interface/General_Interface';
import { AlertifyService } from 'src/app/Service/Alertify.service';
import { NavService } from 'src/app/Service/Nav/Nav.service';
import { TicketCategoryService } from 'src/app/Service/TicketCategory/TicketCategory.service';

@Component({
  selector: 'app-TicketCategoryAdd',
  templateUrl: './TicketCategoryAdd.component.html',
  styleUrls: ['./TicketCategoryAdd.component.scss', '../../ticket-shared.css']
})
export class TicketCategoryAddComponent implements OnInit {
  ErrorMessage = '';

  constructor(
    private TicketCategory_Service:TicketCategoryService,
    private Nav_Service:NavService,
    private Alertify_Service:AlertifyService
  ) { }

  ngOnInit() {

    this.AddNewTicketCategory=new FormGroup({
      id :new FormControl(),
      Title:new FormControl(null, [Validators.required, Validators.pattern(/\S/)]),
    })


    this.Nav_Service.CheckValidPage(1113).subscribe(
      data=>{
        
      }
      ,error=>{
        this.ErrorMessage = ticketRequestError(error); this.Alertify_Service.ErrorMessage(this.ErrorMessage);
      }
    )


  }


  //#region  Form Add

  AddNewTicketCategory:FormGroup;

  get_Form_Title(){
    return this.AddNewTicketCategory.get('Title') as FormControl;
  }

  //#endregion

  InProccessing:boolean=false

  SubmitAddNewTicketCategory(){
    if (this.InProccessing) return;
    this.ErrorMessage = '';
    if (this.AddNewTicketCategory.invalid) { this.AddNewTicketCategory.markAllAsTouched(); return; }
    const record = Empty_General_Interface();
    record.id = 0;
    record.title = this.get_Form_Title().value.trim();
    this.InProccessing = true;
    this.TicketCategory_Service.AddTicketCategory(record).pipe(finalize(() => this.InProccessing = false)).subscribe({
      next: data => {
        if (data.id === -2) { this.ErrorMessage = 'عنوان وارد شده در لیست وجود دارد.'; return; }
        this.AddNewTicketCategory.reset();
        this.Alertify_Service.SuccessMessage('اطلاعات ثبت شد');
      },
      error: error => { this.ErrorMessage = ticketRequestError(error); this.Alertify_Service.ErrorMessage(this.ErrorMessage); }
    });
  }
}
